<div class="search-criteria do-not-print" (keydown)="onKeyDown($event)">
    <div class="row">
        <div class="col-24">
            <h1 class="bottom-10">My Clients</h1>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="error">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li><button>Application Start/End date is required.</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12" *ngIf="this.isAdmin">
            <div class="bottom-10">
                <div class="jqgrid-organization">
                    <Label for="Organization">Organization</Label>
                    <jq-org-dropdown-multiselect [width]="'512'" [disabled]="!this.isAdmin" (onValueChange)="onOrgChange($event)"
                                                 #child>
                    </jq-org-dropdown-multiselect>
                </div>
            </div>
        </div>
        <div [ngClass]="{'col-12': this.isAdmin, 'col-24': !this.isAdmin }">
            <p><strong>Note:  Always confirm 'Start' and 'End' dates before downloading your client activity</strong></p>
            <div>
                <div class="input-wrapper">
                    <JQDatePicker  for="ApplicationStartDate" id="ApplicationStartDate" [label]="'Application Start Date'" [selectedDate]="myClientsCriteria.ApplicationStartDate"
                                  (elementClicked)="onInfoChange('ApplicationStartDate', $event)"></JQDatePicker>
                </div>
            </div>
            <div>
                <div class="input-wrapper">
                    <JQDatePicker for="ApplicationEndDate" id="ApplicationEndDate" [label]="'Application End Date'" [selectedDate]="myClientsCriteria.ApplicationEndDate"
                                  (elementClicked)="onInfoChange('ApplicationEndDate', $event)"></JQDatePicker>
                
                                </div>
            </div>
            <div>
                <ValidatedTextField [label]="'Agent Name'"
                                    [text]="myClientsCriteria.AgentID"
                                    (onValueChange)="onInfoChange('AgentID', $event)"
                                    [disabled]="!this.isAdmin">
                </ValidatedTextField>
            </div>
            <div>
                <button type="submit" id="getEnrollments" class="button primary next-to-field" (click)="onGetEnrollments()">Search</button>
                <button id="searchByMedicare" class="button primary next-to-field" (click)="searchByMedicareID()">Click here to search by Medicare ID Number</button>
            </div>
        </div>
        <!--
        <div [ngClass]="{'col-8': this.isAdmin, 'col-8': !this.isAdmin }">
            <div class="input-wrapper">
                <label>Application Start Date</label>
                <JQDatePicker [selectedDate]="myClientsCriteria.ApplicationStartDate"
                              (elementClicked)="onInfoChange('ApplicationStartDate', $event)"></JQDatePicker>
            </div>
        </div>
        <div class="col-16">
            <div class="input-wrapper">
                <label>Application End Date</label>
                <JQDatePicker [selectedDate]="myClientsCriteria.ApplicationEndDate"
                              (elementClicked)="onInfoChange('ApplicationEndDate', $event)"></JQDatePicker>
            </div>
        </div>
        <div class="col-8">
                <ValidatedTextField [label]="'Agent Name'"
                                    [text]="myClientsCriteria.AgentID"
                                    (onValueChange)="onInfoChange('AgentID', $event)"
                                    [disabled]="!this.isAdmin">
                </ValidatedTextField>
        </div>
        <div [ngClass]="{'col-16': this.isAdmin, 'col-24': !this.isAdmin }">
            <button type="submit" id="getEnrollments" class="button primary next-to-field" (click)="onGetEnrollments()">Search</button>
            <button id="searchByMedicare" class="button primary next-to-field" (click)="searchByMedicareID()">Click here to search by Medicare ID Number</button>
        </div>
        -->

        <!--<div class="col-8">
            <div class="input-wrapper">
                <ValidatedDropDown [selectedValue]="myClientsCriteria.UserType"
                                   [label]="'User Type'"
                                   [disabled]="disabled"
                                   (onValueChange)="onInfoChange('UserType', $event)"
                                   [options]="userTypes">
                </ValidatedDropDown>
            </div>
        </div>-->
    </div>
</div>
<router-outlet></router-outlet>


